module.exports = __webpack_public_path__ + "media/alarm.48ab373e.mp4";